import React from "react";
import ReactDOM from "react-dom/client";
import { store, persistor } from './store/index';
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/App.scss";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { initGlobalErrorHandlers } from "./helpers/error-logger";
import * as Sentry from "@sentry/react";

// Force HTTPS in production
if (window.location.protocol === 'http:' && window.location.hostname !== 'localhost') {
  window.location.replace('https://' + window.location.host + window.location.pathname + window.location.search + window.location.hash);
}

// Sentry. The boundary itself only wraps the Stripe payment forms, see
// components/StripeErrorBoundary.jsx, but init has to run once at startup.
Sentry.init({
  dsn: "https://e2746cf0701b43c67e52a117a9253fdf@o4512128631767040.ingest.us.sentry.io/4512128633405440",
  environment: process.env.REACT_APP_CUSTOM_NODE_ENV || "development",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
      // Mask all input fields by default; Stripe PaymentElement renders in an
      // iframe so Replay cannot capture card details directly, but masking
      // ensures any text visible outside the iframe is also redacted.
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Catch unhandled promise rejections and plain javascript errors. Registered
// before rendering so errors thrown while the app boots are logged too.
initGlobalErrorHandlers();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>

    </Provider>
  </React.StrictMode>
);

reportWebVitals();
